import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Autocomplete, Button, ButtonGroup, Skeleton, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { NotificationDAO } from '../../../data/SystemManagementDAO';
import { ActionIcons } from '../../../Iconography';
import { AutosizedTextField } from '../../common/AutosizedTextField';
import { SingleEntityAutoQuery } from '../../generic/EntityAutoQuery';
import { SingleGroupAutoQuery } from '../../generic/GroupAutoQuery';
import { SubscriptionDeliveryOptions } from '../Subscriptions/DeliveryOption';
const debug = process.env.REACT_APP_DEBUG && false;
var Scope;
(function (Scope) {
    Scope["PERSON"] = "Person";
    Scope["USER"] = "User";
    Scope["GROUP"] = "Group";
    Scope["CUSTOMER"] = "Customer";
    Scope["ALL"] = "All";
})(Scope || (Scope = {}));
export const Broadcast = ({ contextCustomer, user, userSelectedGroup }) => {
    const [scope, setScope] = useState(Scope.USER);
    const [target, setTarget] = useState(null);
    const [methods, setMethods] = useState([]);
    const [message, setMessage] = useState('');
    const [sending, setSending] = useState(false);
    useEffect(() => setTarget(null), [scope]);
    let targetEntityType = null;
    switch (scope) {
        case Scope.PERSON:
        case Scope.USER:
        case Scope.GROUP:
        case Scope.CUSTOMER:
            targetEntityType = scope;
            break;
        case Scope.ALL:
            targetEntityType = null;
            break;
    }
    const send = async () => {
        setSending(true);
        const res = await NotificationDAO.broadcastMessage({
            contextObject: target,
            methods,
            message,
        });
        debug && console.log('Notification Broadcast send:', res);
        setSending(false);
    };
    if (userSelectedGroup !== undefined && userSelectedGroup !== 'HyperUser')
        return _jsx(Alert, { severity: "warning", children: "You must be a Hyper User to use this feature!" });
    return contextCustomer !== undefined && user !== undefined ? (_jsxs(Stack, { gap: 1, children: [_jsx(Typography, { variant: "h5", children: "Broadcast Notification Message" }), _jsx(Typography, { children: "Select a target, some delivery method(s), and write a message to send." }), _jsx(Stack, { direction: "row", children: _jsx(ButtonGroup, { disabled: sending, children: Object.entries(Scope).map(([_, name]) => (_jsx(Button, { variant: scope === name ? 'contained' : 'outlined', onClick: () => setScope(name), children: name }, name))) }) }), (targetEntityType === 'Customer' || targetEntityType === 'User' || targetEntityType === 'Person') && (_jsx(Stack, { direction: "row", children: _jsx(SingleEntityAutoQuery, { contextObject: contextCustomer, entityType: targetEntityType, currentEntity: target, setCurrentEntity: setTarget, label: "Target", fullWidth: false, required: true, disabled: sending }) })), targetEntityType === 'Group' && (_jsx(Stack, { direction: "row", children: _jsx(SingleGroupAutoQuery, { contextObject: contextCustomer, entityType: "User", currentGroup: target, setCurrentGroup: setTarget, label: "Target", fullWidth: false, required: true, disabled: sending }) })), _jsx(Stack, { direction: "row", children: _jsx(Autocomplete, { value: methods, onChange: (_, value) => setMethods(value), options: Object.keys(SubscriptionDeliveryOptions), getOptionLabel: (o) => SubscriptionDeliveryOptions[o], multiple: true, size: "small", disabled: sending, renderInput: (params) => _jsx(AutosizedTextField, { label: "Delivery method", ...params, error: methods.length === 0 }) }) }), _jsx(Stack, { direction: "row", children: _jsx(AutosizedTextField, { label: "Message", size: "small", value: message, onChange: (e) => setMessage(e.target.value), error: message.length === 0, disabled: sending, slotProps: {
                        input: {
                            sx: { minWidth: '10em' },
                        },
                    } }) }), _jsx(Stack, { direction: "row", children: _jsx(Button, { variant: "contained", size: "large", color: "success", onClick: send, endIcon: _jsx(ActionIcons.Send, {}), disabled: sending || (target === null && scope !== Scope.ALL) || methods.length === 0 || message.length === 0, loading: sending, loadingPosition: "end", children: "Send" }) })] })) : (_jsx(Skeleton, { variant: "rounded", width: '100cqw', height: '100cqh' }));
};
